import React from 'react'
import FormROValue from '../../../library/form/components/FormROValue1';
import FormInput from '../../../library/form/components/FormInput';
import FormLink from '../../../library/form/components/FormLink';
import FormLabel from '../../../library/form/components/FormLabel'
import FormRichText from '../../../library/form/components/FormRichText'
import FormSH from '../../../library/form/components/FormSH';
import FormWrapper from '../../../library/form/components/FormWrapper';

const InvTrnHeaderSH1 = (props) => {
    const { formObject, headerKey } = props;

    return (
        <div className="uiEditableContent uiImportDetailsForm">
            <div className="uiRow">
                <ul>
                    <li style={{display:"none"}}>
                        <span className="uiLbl">
                            <FormLabel formObject={formObject} headerKey={headerKey} action={{ paramName: "docId" }} value="Document ID" />
                        </span>
                        <FormROValue format="#" formObject={formObject} headerKey={headerKey} action={{ paramName: "docId" }} className='uiVal' />
                    </li>
                    <li>
                        <span className="uiLbl">
                            <FormLabel formObject={formObject} headerKey={headerKey} action={{ paramName: "shInvDate" }} value="Document Date" />
                        </span>
                        <FormInput formObject={formObject} headerKey={headerKey} id="relationSince" className="uiInput"
                            action={{ InputType: "dp", paramName: "shInvDate" }} />
                    </li>
                    <li>
                        <span className="uiLbl">
                            <FormLabel formObject={formObject} headerKey={headerKey} action={{ paramName: "profile1" }} value="" />
                        </span>
                        <FormLink formObject={formObject} headerKey={headerKey}
                                action={{
                                    paramName: "profile1",
                                    actionId: "show",  
                                    containerKey: "popup"
                                }}
                                linkProp={{target: "_blank"}}
                            ></FormLink>

                    </li>
                    <FormWrapper customWrapper="li" headerKey={headerKey} formObject={formObject} action={{ paramName: "reqbydate" }} >
                        <span className="uiLbl">
                            <FormLabel formObject={formObject} headerKey={headerKey} action={{ paramName: "reqbydate" }} value="Required on" />
                        </span>
                        <FormInput formObject={formObject} headerKey={headerKey} className=""
                            action={{ InputType: "dp", paramName: "reqbydate" }} />
                    </FormWrapper>
                    <li>
                        <span className="uiLbl">
                            <FormLabel formObject={formObject} headerKey={headerKey} action={{ paramName: "inchrgUser" }} value="Incharge User" />
                        </span>
                        <FormInput formObject={formObject} headerKey={headerKey} className="uiInput"
                            action={{ InputType: "ac", paramName: "inchrgUser", acMethod: "UserNames" }} />
                    </li>
                    <FormWrapper customWrapper="li" headerKey={headerKey} formObject={formObject} action={{ paramName: "transCat" }} >
                        <span className="uiLbl">
                            <FormLabel formObject={formObject} headerKey={headerKey} action={{ paramName: "transCat" }} value="Category" />
                        </span>
                        <FormInput formObject={formObject} headerKey={headerKey} className="uiInput"
                            action={{ InputType: "ac", paramName: "transCat", acMethod: "CategoryDetail", acDepCtrl: { dparam: '%dataList.valLCat' } }} />
                    </FormWrapper>
                    <FormWrapper customWrapper="li" headerKey={headerKey} formObject={formObject} action={{ paramName: "profile2" }} >
                        <span className="uiLbl">
                            <FormLabel formObject={formObject} headerKey={headerKey} action={{ paramName: "profile2" }} value="ID" />
                        </span>
                        <FormInput formObject={formObject} headerKey={headerKey} className="uiInput" style={{width:"200px"}}
                            action={{ InputType: "ac", paramName: "profile2", acMethod: "ProfileName", acDepCtrl: { dparam: "%dataList.valLDT", reqPerm: 1 } }}
                        />
                        <FormSH formObject={formObject} headerKey={headerKey}
                            action={{ actionId: "new", paramName: "profile2",  actionName: "proComp", actionParam: {}, containerKey: "popup" }}
                        ></FormSH>
                    </FormWrapper>
                    <FormWrapper customWrapper="li" headerKey={headerKey} formObject={formObject} action={{ paramName: "address2" }} >
                        <span className="uiLbl">
                            <FormLabel formObject={formObject} headerKey={headerKey} action={{ paramName: "address2" }} value="Address" />
                        </span>
                        <FormRichText formObject={formObject} headerKey={headerKey} rows="2" className="uiFrmText" style={{width:"200px"}}
                            action={{ InputType: "ac", paramName: "address2", acMethod:"ProfileAddress", acValidate: "0", acDepCtrl:{ dptid: "%dataList.valLDT", dpid: "#profile2" } }}
                        />
                    </FormWrapper>
                    <FormWrapper customWrapper="li" headerKey={headerKey} formObject={formObject} action={{ paramName: "profile3" }} >
                        <span className="uiLbl">
                            <FormLabel formObject={formObject} headerKey={headerKey} action={{ paramName: "profile3" }} value="ID" />
                        </span>
                        <FormInput formObject={formObject} headerKey={headerKey} className="uiInput" style={{width:"200px"}}
                            action={{ InputType: "ac", paramName: "profile3", acMethod: "ProfileName", acDepCtrl: { dparam: "%dataList.valLDT", reqPerm: 1 } }}
                        />
                        <FormSH formObject={formObject} headerKey={headerKey}
                            action={{ actionId: "new", paramName: "profile3",  actionName: "proComp", actionParam: {}, containerKey: "popup" }}
                        ></FormSH>
                    </FormWrapper>
                    <FormWrapper customWrapper="li" headerKey={headerKey} formObject={formObject} action={{ paramName: "address3" }} >
                        <span className="uiLbl">
                            <FormLabel formObject={formObject} headerKey={headerKey} action={{ paramName: "address3" }} value="Address" />
                        </span>
                        <FormRichText formObject={formObject} headerKey={headerKey} rows="2" className="uiFrmText" style={{width:"200px"}}
                            action={{ InputType: "ac", paramName: "address3", acMethod:"ProfileAddress", acValidate: "0", acDepCtrl:{ dptid: "%dataList.valLDT", dpid: "#profile3" } }}
                        />
                    </FormWrapper>
                    <FormWrapper customWrapper="li" headerKey={headerKey} formObject={formObject} action={{ paramName: "shInvAmount" }} >
                        <span className="uiLbl">
                            <FormLabel formObject={formObject} headerKey={headerKey} action={{ paramName: "shInvAmount" }} value="Amount" />
                        </span>
                        <FormInput formObject={formObject} headerKey={headerKey} className="uiVal"
                                action={{ InputType: "input", paramName: "shInvAmount" }}
                            />
                    </FormWrapper>
                    <FormWrapper customWrapper="li" headerKey={headerKey} formObject={formObject} action={{ paramName: "currency" }} >
                        <span className="uiLbl">
                            <FormLabel formObject={formObject} headerKey={headerKey} action={{ paramName: "currency" }} value="Currency" />
                        </span>
                        <FormInput formObject={formObject} headerKey={headerKey} className=""
                            action={{ InputType: "ac", actionName: "invTrans", actionId:"refresh", paramName: "currency", acMethod: "CurrencyName", acDepCtrl: { 'dparam': "%dataList.valLCat" },actionParam:{updateCurrency:"1"} }}
                        />
                    </FormWrapper>
                    <FormWrapper customWrapper="li" headerKey={headerKey} formObject={formObject} action={{ paramName: "exRate" }} >
                        <span className="uiLbl">
                            <FormLabel formObject={formObject} headerKey={headerKey} action={{ paramName: "exRate" }} value="Exchange Rate" />
                        </span>
                        <FormInput formObject={formObject} headerKey={headerKey} className=""
                            action={{ InputType: "input", actionName: "invTrans", actionId:"refresh", paramName: "exRate", actionParam:{updateCurrency:"1"} }}
                        />
                    </FormWrapper>
                    <FormWrapper customWrapper="li" headerKey={headerKey} formObject={formObject} action={{ paramName: "exRateHelper" }} >
                        <span className="uiLbl">
                            <FormLabel formObject={formObject} headerKey={headerKey} action={{ paramName: "exRateHelper" }} value="Sample Amount" />
                        </span>
                        <FormROValue formObject={formObject} headerKey={headerKey} action={{ paramName: "exRateHelper" }} />
                    </FormWrapper>
                    <li>
                        <span className="uiLbl">
                            <FormLabel formObject={formObject} headerKey={headerKey} action={{ paramName: "refExNo" }} value="Ref. No (Ex)" />
                        </span>
                        <FormInput formObject={formObject} headerKey={headerKey} id="refExNotxt" className="uiInput"
                            action={{ InputType: "input", paramName: "refExNo" }} />
                    </li>
                    <li>
                        <span className="uiLbl">
                            <FormLabel formObject={formObject} headerKey={headerKey} action={{ paramName: "refExDate" }} value="Ref. Date (Ex)" />
                        </span>
                        <FormInput formObject={formObject} headerKey={headerKey} className="" id="refExDatetxt"
                            action={{ InputType: "dp", paramName: "refExDate" }} />
                    </li>
                </ul>
            </div>
        </div>
    )
}

export default InvTrnHeaderSH1;
